import { render, staticRenderFns } from "./related-prompts-preview.view.vue?vue&type=template&id=0f1b047c&scoped=true"
import script from "./related-prompts-preview.view.vue?vue&type=script&lang=ts"
export * from "./related-prompts-preview.view.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-preview.view.vue?vue&type=style&index=0&id=0f1b047c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b047c",
  null
  
)

export default component.exports